import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { NationalStockPageRoutingModule } from './national-stock-routing.module';

import { NationalStockPage } from './national-stock.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    NationalStockPageRoutingModule
  ],
  declarations: [NationalStockPage]
})
export class NationalStockPageModule {}
